var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', [_vm._m(0), _c('div', {
    staticClass: "footer-text"
  }, [_vm._v(" Свяжитесь с нами через "), _c('router-link', {
    attrs: {
      "to": "/feedback"
    }
  }, [_vm._v("форму обратной")]), _vm._v(" связи или написав на почту "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.$config.site.email
    }
  }, [_vm._v(_vm._s(_vm.$config.site.email))])], 1), _vm.modal !== false ? _c('div', {
    staticClass: "modal-container profile-container"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', [_vm.modal === 'passwordChange' ? _c('password-change-form', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.closeOutside,
      expression: "closeOutside"
    }]
  }) : _vm._e(), _vm.modal === 'logout' ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.closeOutside,
      expression: "closeOutside"
    }],
    staticClass: "modal exit-modal"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Вы уверены, что хотите выйти?")]), _c('div', {
    staticClass: "exit-buttons-container input-group"
  }, [_c('a', {
    staticClass: "button blue",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.close($event);
      }
    }
  }, [_vm._v("Остаться")]), _c('a', {
    staticClass: "button black",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logout($event);
      }
    }
  }, [_vm._v("Выйти")])])]) : _vm._e()], 1)])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "offer"
  }, [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "/oferta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Оферта")])]);
}]

export { render, staticRenderFns }